import { api } from "./rtkAPI";
import { lhwpath } from "../apiRoutes";

/**
 * "Aaj ka rate" band — GET /global/rate-board (lhw-backend-main, Phase 2.3).
 * Rate ex-GST per priceStructureUnit; gstPercent item ka apna (cement 28% ho sakta hai).
 * Endpoint na mile to band chup-chaap nahi dikhta (component error par null deta hai).
 */
export interface RateBoardItem {
  companyProductId: string;
  itemName: string;
  companyName?: string;
  categoryName?: string;
  unit?: string;
  rate: number;
  gstPercent: number;
  image?: string;
}

export interface RateBoardResponse {
  success: boolean;
  updatedAt?: string;
  items: RateBoardItem[];
}

export const RateBoardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    rateBoard: builder.query<RateBoardResponse, void>({
      query: () => ({ url: `${lhwpath}/global/rate-board`, method: "GET" }),
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useRateBoardQuery } = RateBoardApi;
